import React, { useState, useEffect, useContext } from "react";
import { NavLink, Link } from 'react-router-dom';

import MenuItems from './MenuItems';

//import normalLogo from '../../assets/images/logos/logo.png';
import stickyLogo from '../../assets/images/logos/logo.png';


import axios from "axios";
import { Input, Stack, Box, Typography, useTheme, Button, IconButton} from "@mui/material";
import styled from "styled-components";
//import { Link } from "react-scroll";

import InputBase from "@mui/material/InputBase";
import {Badge, theme} from "@material-ui/core";
import { useCollapse } from "react-collapsed";

import urls from './../../constants/urls';
import { ColorModeContext, tokens } from "./../theme";
import LoginIcon from '@mui/icons-material/Login';


const Header = (props ) => {
	const { topbarEnable, menuCategoryEnable, headerClass, parentMenu, headerNormalLogo, headerStickyLogo } = props;

	const [menuOpen, setMenuOpen] = useState(false)
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		// Sticky is displayed after scrolling for 100 pixels
		const toggleVisibility = () => {
			if (window.pageYOffset > 100) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener("scroll", toggleVisibility);

		return () => window.removeEventListener("scroll", toggleVisibility);
	}, []);


	 const theme = useTheme();
		const colors = tokens(theme.palette.mode);
		const colorMode = useContext(ColorModeContext);
		
		const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);
		
	
			const [formDataUserLoginEXT, setFormDataUserLoginEXT]=useState({
				 
				  users_id: 0,// = models.BigAutoField(primary_key=True)
				  first_name: 'Default',// = models.CharField(max_length=32)
				  middle_name: 'Default',// = models.CharField(max_length=32)
				  last_name: 'Default',// = models.CharField(max_length=32)
				  full_name: 'Default',// = models.CharField(max_length=64)
				  gender: 'Default',// = models.CharField(max_length=16)
				  mobile_number: '',// = models.CharField(max_length=16)
				  user_email: 'Default',// = models.CharField(max_length=32)
				  date_of_birth: '1980-01-01 00:00:00.000',// =models.DateTimeField(max_length=32, null=True)
				  password_id: 0,// = models.IntegerField()
				  user_password: '',// =models.CharField(max_length=128)
				  login_category_id: 0,// = models.IntegerField()
				  login_category_name: 'Default',// =models.CharField(max_length=32)
			  })
	
	
		
		const handleChangeInput = (e) =>{
			const {name, value } =e.target
			setFormDataUserLoginEXT({
			 ...formDataUserLoginEXT,
			 [name]: value
			})
			//
			 
			 //
			 setErrors({});
		   }
		
		
		
	  const handleButtonSubmit2 = () =>{
		
		console.log("formDataUserLoginEXT.mobile_number=" + formDataUserLoginEXT['mobile_number'])
		console.log("formDataUserLoginEXT.user_password=" + formDataUserLoginEXT['user_password'])
		 
		 let newErrors=validateForm(formDataUserLoginEXT);
		 setErrors(newErrors);
		 
		 console.log("errors.lenght=" + Object.keys(newErrors).length)
		 if(Object.keys(newErrors).length===0){
		   console.log("len0")
		   Login()
		 }
		 else{
		   console.log("len1")
		 }
		 /***
		 
		 ***/
	 
	 }
	 
	 const [errors, setErrors]=useState({});
	 
	 const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
    
	
	 const Login=()=>{
     
     
		//let url = API_URL;
		let APIURL= APIROOTURL + "UserLoginViewEXT"
		let picsId=0;
		axios
		  .post(APIURL, formDataUserLoginEXT, {
			headers: {
			  "Content-type": "multipart/form-data",
			},
		  })
		  .then((res) => {
			console.log("res.data.msg=" + res.data.msg)
			let usersId=res.data.usersId;
		   let fullName=res.data.username; //res.data.fullName;
		   
		   console.log("res.data.fullName=" + res.data.fullName)
		   // schoolDetails
		   
		   let schoolDetails=res.data.schoolDetails;
		   
		   console.log("res.data.schoolDetails.fullName=" + res.data.schoolDetails.schoolName)
		   
		   console.log("res.data.schoolDetails['schoolName']=" + res.data.schoolDetails['schoolName'])
	
		   let loginCategoryName=res.data.category;
		   let userRolesList=[];//res.data.qr;
		  
		   let loginDetails=res.data.loginDetails;
		   
		   let loginDetailsForm={
			loginCategory: loginCategoryName,
			
			userPassword: formDataUserLoginEXT['user_password'],
			fullName: fullName,
			usersId: usersId,
		  }
							//User login was successful
		   if (res.data.msg==="User login was successful"){
			//loadUserRoles=(true, usersId, fullName, loginCategoryName)
			//alert("1");
			props.sendDataToParent(true, usersId, fullName, loginCategoryName, userRolesList, loginDetailsForm, schoolDetails, loginDetails);
			//console.log("2");
		   }
		   else{
			alert("Login failed");
		   }
		   //
	
		  })
		  .finally(() => {
		   
		
		  })
		  .catch((err) => console.log(err));
	
	   }   
	
	
		 
	const validateForm = (data) =>{
	  const errors={};
	  if(data.mobile_number==="" || data.mobile_number==""){
		console.log("if " + ", data.name=" + data.mobile_number)
		errors.mobile_number='Please enter mobile number';
	   }
	   else{
		console.log("else " + ", data.mobile_number=" + data.mobile_number)
	   }
	
	   if(data.user_password==="" || data.user_password==""){
		console.log("if " + ", data.name=" + data.user_password)
		errors.user_password='Please enter password';
	   }
	   else{
		console.log("else " + ", data.user_password=" + data.user_password)
	   }
	  
	  return errors;
	
	}
	
		  
	
	  const handleButtonSubmit = () =>{
		
		console.log("formDataUserLoginEXT.mobile_number=" + formDataUserLoginEXT['mobile_number'])
		console.log("formDataUserLoginEXT.user_password=" + formDataUserLoginEXT['user_password'])
		 
		 let newErrors=validateForm(formDataUserLoginEXT);
		 setErrors(newErrors);
		 
		 console.log("errors.lenght=" + Object.keys(newErrors).length)
		 if(Object.keys(newErrors).length===0){
		   console.log("len0")
		   Login()
		 }
		 else{
		   console.log("len1")
		 }
		 /***
		 
		 ***/
	 
	 }
	 
	 

	return (
		<>

			<header id="react-header" className={headerClass ? headerClass : 'react-header react-header-three'}>
				<div className={isVisible ? 'header-area react-sticky' : 'header-area'}>
					{
						topbarEnable ? 
						<div className="topbar-area style1">
							<div className="container">
								<div className="row">
									<div className="col-lg-7">
										<div className="topbar-contact">
										<ul>                                   
											<li>
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-phone"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
												<a href="tel:(+1)3344999999"> (+255) 743 794560</a>
											</li>
											<li>
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
												<a href="mailto:info@etriangle.ac.tz">info@etriangle.ac.tz</a>
											</li>
											
										</ul>
										</div>
									</div>
									<div className="col-lg-5 text-right">
										<div className="toolbar-sl-share">
											<ul className="social-links">
												<li><a href="#"><span aria-hidden="true" className="social_facebook"></span></a></li>
												<li><a href="#"><span aria-hidden="true" className="social_twitter"></span></a></li>
												<li><a href="#"><span aria-hidden="true" className="social_linkedin"></span></a></li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div> : ''
					}
					<div className="menu-part">
						<div className="container">
							<div className="react-main-menu">
								<nav>
									
									
									<div className="menu-toggle">
										<div className="logo">
											{
												isVisible ? 
												<NavLink to="/" className="logo-text">
													<img 
													src={headerStickyLogo ? 
													headerStickyLogo : 
													'https://www.bfatechnologies.tech/images/assets/images/logos/logo.png'} alt="" />
												</NavLink> :
												<NavLink to="/" className="logo-text">
													<img 
													src={headerNormalLogo ? 
													headerNormalLogo : 
													'https://www.bfatechnologies.tech/images/assets/images/logos/logo.png'} alt="" />
												</NavLink>
											}
										</div>
										<button type="button" id="menu-btn" className={menuOpen ? "mobile-menu-btn open" : "mobile-menu-btn"} onClick={() => {setMenuOpen(!menuOpen)}}>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
										</button>
									</div>
									


									
									<div className={menuOpen ? "react-inner-menus menu-open" : "react-inner-menus"}>
										{
											menuCategoryEnable ?
											<div className="cate-part">
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-more-vertical"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-more-vertical"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-more-vertical"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
												<ul className="react-category-menu">
													<li><NavLink to="#">Categories <i className="arrow_carrot-down"></i></NavLink> 
														<ul>
															{/*** *
															<li><NavLink to="/course">English Book</NavLink></li>
															<li><NavLink to="/course">Math Book</NavLink></li>
															<li><NavLink to="/course">Story Book</NavLink></li>
															***/}
														</ul>
													</li>
												</ul>
											</div> : ''
										}
										<ul id="backmenu" className="react-menus react-sub-shadow">
											<MenuItems 
												parentMenuEXT = {parentMenu}
												
											/>
										</ul>  

										   
										{/*** *
										<div className="searchbar-part"> 
											<form className="search-form">
												<input type="text" className="form-input" placeholder="Search Course" />
												
												<NavLink to="/course" className="form-button">
													<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
												</NavLink>
											
											</form>
										</div>
										***/}
									</div>

            <div>
              <a {...getToggleProps()}  style={{ padding: "1px 1px 1px 0", marginTop: "50px", fontSize: "14px", color:"indigo" }}>
                {isExpanded ? "Close" : "Log in"}
              </a>
              <section {...getCollapseProps()}>
                {/***Collapsed content 🙈***/}
                <Stack direction="row" spacing={2} sx={{width: '320px', height: '40px'}}>
                <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            flex={12}
           >
            {/** *
            <IconButton type="button" sx={{ p: 1 }}>
              <PhoneIcon />
            </IconButton>
            ***/}
            <InputBase sx={{ ml: 2, flex: 1, fontSize: '12px', }} 
            placeholder="Mobile number" 
            name="mobile_number"
            onChange={handleChangeInput}
            />
            {/***{ errors.mobile_number && (<span> {errors.mobile_number} </span>)}***/}
          </Box>

          {/*** *
          </Stack>

          <Stack direction="row" spacing={2} sx={{width: '250px', height: '40px'}}>
           ***/ }
          <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            marginTop="20px"
            marginBottom="10px"
            flex={12}
           >
            {/*** *
            <IconButton type="button" sx={{ p: 1 }}>
              <PasswordIcon />
            </IconButton>
            ***/}
            <Input sx={{ ml: 2, flex: 1, fontSize: '12px', width: '100%'}} 
            type="password"
            name="user_password"
            placeholder="Password"
            onChange={handleChangeInput}


            />
            {/** *
            { errors.user_password && (<span> {errors.user_password} </span>)}
            ***/}
          </Box>

          <Button 
      type="Submit"  color="secondary" variant="contained"
       onClick={handleButtonSubmit}
       sx={{ width: '40px', marginLeft: '2px', marginTop: '10px'}}
       startIcon={<LoginIcon />}
       >
       LOGIN
      </Button>
                </Stack>
                </section>
            </div>

                                       

								</nav>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
}

export default Header;